export const routerPaths = {
  landingPage: "/",
  registrationDocument: "/registrationDocument",
  selectAccount: "/onboarding/selectAccount",
  signIn: "/signIn",
  signUp: "/signUp",
  verifyEmail: "/verifyEmail",
  verifyPhoneNumber: "/verifyPhoneNumber",
  verificationSuccessful: "/verificationSuccessFul",
  dashboard: "/dashboard",
  boat: "/boat",
  booking: "/booking",
  wallet: "/wallet",
  createBoat: "/boat/createBoat",
  editPhotos: "/edit_photos",
  editPricing: "/edit_pricing",
  settings: "/settings",
  profile: "/profile",
  hireHistory: "/hireHistory",
  createWallet: "/wallet/createWallet",
  transaction: "/wallet/transactions",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
};
